export enum SaveResultType {
    SUCCESS, ERROR, NO_CHANGE
}